module.exports = __webpack_public_path__ + "img/UOBT.35a6a24b.png";